import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { FaqItemProps as Props } from './types';

export const FaqItem = memo(({ className, item }: Props) => {
  return (
    <Styled.Wrapper className={classnames('FaqItem', className)} sx={SX.root}>
      <AccordionSummary
        expandIcon={<Icon name="arrow-accordion" size={15} />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={SX.accordionSummary}
      >
        <Typography variant="body2" fontWeight={700} color="grey.900">
          {item?.title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography
          variant="body4"
          fontWeight={500}
          color="grey.800"
          textAlign="left"
        >
          {item?.answer}
        </Typography>
      </AccordionDetails>
    </Styled.Wrapper>
  );
});

FaqItem.displayName = 'FaqItem';
